<template>
    <VJoyPanel>
        <template #panel-title><h2>Web preferences</h2></template>
        <template #panel-body>
            <VJoyCheckbox label="Onboarding popup" :checked="onboardingAcknowledged" @update:checked="updateOnboardingAcknowledgment" />
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox, VJoyPanel} from '@maltjoy/core-vue';
    import {useProfileStore} from '~/store/profileStore';
    import {useWebPreferencesStore} from '~/store/webPreferences.store';

    const webPreferencesStore = useWebPreferencesStore();
    const {adminAcknowledgeOnboarding, getWebPreferences} = webPreferencesStore;
    const {webPreferences} = storeToRefs(webPreferencesStore);
    const {profile} = storeToRefs(useProfileStore());

    const onboardingAcknowledged = computed<boolean>(() => (webPreferences.value && webPreferences.value.onboardingAcknowledged) || false);

    async function updateOnboardingAcknowledgment(acknowledged: boolean) {
        await adminAcknowledgeOnboarding(acknowledged);
        await reloadWebPreferences();
    }

    async function reloadWebPreferences() {
        await getWebPreferences(profile.value!.accountId);
    }
</script>
